import { render, staticRenderFns } from "./UpdateSuppliyPrice.vue?vue&type=template&id=00195104&scoped=true&lang=pug&"
import script from "./UpdateSuppliyPrice.vue?vue&type=script&lang=ts&"
export * from "./UpdateSuppliyPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00195104",
  null
  
)

export default component.exports